import { ButtonHTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

export interface AnchorButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  linkColor?: boolean
  type?: 'button'
}

export const AnchorButton = styled.button.attrs({
  type: 'button',
})<AnchorButtonProps>`
  background-color: transparent;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  display: inline;
  margin: 0;
  padding: 0;
  font-family: inherit !important;
  text-decoration: none;
  color: ${({ linkColor, theme }) =>
    linkColor ? theme.primaryColor : theme.primaryFontColor};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;
      opacity: 0.5;
    `}

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    outline: none;
    border: none;
  }
`
